import { render, staticRenderFns } from "./ResultadoBusca.vue?vue&type=template&id=6eba0bb0"
import script from "./ResultadoBusca.vue?vue&type=script&lang=js"
export * from "./ResultadoBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports